import React from 'react';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export const stateColorSwitch = (state: string | null) : [string, React.ReactNode | undefined] => {
  switch (state) {
    case 'success':
      return ['secondary', <CheckCircleIcon style={{ color: 'green', fontSize: '14px', marginLeft: '2px' }} />];
    case 'error':
      return ['error', <CancelIcon style={{ color: 'red', fontSize: '14px', marginLeft: '2px' }} />];
    default:
      return ['primary', undefined];
  }
};
export const checkPassLength = (firstPassword: string) => {
  if (firstPassword.length === 0) {
    return null;
  }
  if (firstPassword.length >= 8 && firstPassword.length <= 15) {
    return 'success';
  }
  return 'error';
};
export const checkPassLettersAndNumbers = (firstPassword: string) => {
  if (firstPassword.length === 0) {
    return null;
  }
  const paswd = /^(?=.*[a-zA-Z])(?=.*[0-9]).{1,}$/;
  if (paswd.test(firstPassword)) {
    return 'success';
  }
  return 'error';
};
export const checkPassSpecialCharacter = (firstPassword: string) => {
  if (firstPassword.length === 0) {
    return null;
  }
  const paswd = /^(?=.*[@$!%*#?&^.-]).{1,}$/;
  if (paswd.test(firstPassword)) {
    return 'success';
  }
  return 'error';
};
export const checkPassDiff = (firstPassword: string, lastPassword: string) => {
  if (lastPassword.length === 0) {
    return null;
  }
  if (firstPassword !== lastPassword) {
    return 'error';
  }
  return 'success';
};

export const requestStyle = {
  display: 'flex',
  alignItems: 'center',
  height: '1.4em',

};
